import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState = {
  isModalOpen: false,
};

const modalSlice = createSlice({
  name: 'announceModal',
  initialState,
  reducers: {
    toggleModal: (state) => {
      const newState = state;
      newState.isModalOpen = !state.isModalOpen;
    },
  },
});

export const { toggleModal } = modalSlice.actions;

export const selectItems = (state) => state.announceModal.isModalOpen;

export default modalSlice.reducer;
